// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"917":"fd1de3503c7cc76f","941":"d4ef038b98e5d6f7","979":"54f2f33c660ad29f"}[chunkId] + ".js";
};